import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * <amaya-variant-sync data-block="…">
 * Wraps an Amaya product block. When the shopper picks another variant, Horizon fetches the
 * re-rendered section; this element finds its twin in that HTML (same data-block id) and morphs
 * its children, so delivery promise, low-stock line, Payflex amount and back-in-stock form
 * always match the selected size/colour.
 */
class AmayaVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
  }

  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const key = this.dataset.block;
        const twin = detail.html.querySelector(`amaya-variant-sync[data-block="${key}"]`);
        if (!twin) return;
        morph(this, twin, { childrenOnly: true });
        this.dispatchEvent(new CustomEvent('amaya:rerender', { bubbles: true }));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[amaya-variant-sync]', error);
      });
  };
}

if (!customElements.get('amaya-variant-sync')) {
  customElements.define('amaya-variant-sync', AmayaVariantSync);
}
